import React from 'react';
import CookieConsent from 'gatsby-core-theme/src/components/organisms/cookie-consent';

export default (props) => (
  <CookieConsent {...props} settingsButtonType='tertiary' buttonSize='s' settingsCookie={true}>
    <p>
      We use cookies in order to optimise our site and improve your experience with us. By using the
      site you consent to our &nbsp;
      <a href="/cookie-policy" className="cookie-consent-gtm">
        Cookie Policy
      </a>
      .
    </p>
  </CookieConsent>
);
